export default __webpack_public_path__ + "static/useful2-0a8645dfb4cae21255d2ebc3d950b55b.jpeg";